<div class="simple_popin">
  <div class="simple_popin-content">
    <ng-content select="[content]"></ng-content>
  </div>

  <div class="simple_popin-buttons">
    <ng-content select="[buttons]"></ng-content>
  </div>
</div>

<div class="simple_popin-overlay" (click)="doClose()">
</div>
